export default __webpack_public_path__ + "static/media/sentencesinput_locked_crown.156959a2.svg";